import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import anime from "animejs/lib/anime.es.js";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      anime({
        targets: menuRef.current,
        opacity: [0, 1],
        translateY: [-20, 0],
        duration: 400,
        easing: "easeOutQuad",
      });
      anime({
        targets: menuRef.current.querySelectorAll(".Link-button-header"),
        opacity: [0, 1],
        scale: [0.9, 1],
        duration: 300,
        delay: anime.stagger(100, { start: 200 }),
        easing: "easeOutQuad",
      });
    } else {
      anime({
        targets: menuRef.current,
        opacity: [1, 0],
        translateY: [0, -20],
        duration: 300,
        easing: "easeInQuad",
      });
    }
  }, [isOpen]);

  return (
    <div className="header-container">
      <ul>
        <li>
          <Link to="/">
            <img src="/logo.png" className="logo" alt="Логотип" />
          </Link>
        </li>
        <li>
          <Link className="Link" to="/">
            Главная
          </Link>
        </li>
        <li>
          <Link className="Link" to="/frameworks">
            Фреймворки
          </Link>
        </li>
        <li>
          <Link className="Link" to="/about">
            О нас
          </Link>
        </li>
      </ul>

      <div className="menu-container">
        <button className="menu-button" onClick={() => setIsOpen(!isOpen)}>
          ≡
        </button>
        {isOpen && (
          <ul className="menu-list" ref={menuRef}>
            <li>
              <Link className="Link-button-header" to="/">
                Главная
              </Link>
            </li>
            <li>
              <Link className="Link-button-header" to="/sites">
                Сайты
              </Link>
            </li>
            <li>
              <Link className="Link-button-header" to="/contacts">
                Контакты
              </Link>
            </li>
            <li>
              <Link className="Link-button-header" to="/partners">
                Партнёрки
              </Link>
            </li>
            <li>
              <Link className="Link-button-header" to="/about">
                О нас
              </Link>
            </li>
            <li>
              <Link className="Link-button-header" to="/frameworks">
                Фреймворки
              </Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
}